<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="75" label-position="right" @submit.native.prevent>
      </Form>
      <Table :columns="columns2" :data="formInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="action">
          <a @click="detail(row.advert_group_id)">图片列表</a>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
  </div>
</template>

<script>
import { advGroupList } from '@/api/advert'
export default {
  name: 'groupList',
  components: {},
  inject: ['reload'],
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        key: ''
      },
      dataCount: 0,
      formInfo: [],
      loading: false,
      advert_group_id: 0,
      ids: 0,
      columns2: [
        {
          title: 'ID',
          key: 'advert_group_id',
          minWidth: 120
        },
        {
          title: '轮播组名称',
          key: 'title',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        }
      ]
    }
  },
  created () {
    this.advertList()
  },
  methods: {
    advertList () {
      this.loading = true
      advGroupList(this.userForm).then(res => {
        let data = res.data
        this.formInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.advertList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.advertList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    detail (id) {
      this.$router.push({ path: '/admin/advertPic/lb/' + id })
    }
  }
}
</script>
